import axios from './axios-auth';

const emailPassword = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/emailpassword',
      params: params,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from emailPassword');
      });
  });

const getUserPointsById = (userId) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getuserpoints',
      params: userId,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('second time got error');
      });
  });

const getUserDetailsById = (userId) =>
  new Promise((resolve, reject) => {
    axios({
      url: 'hr-adm/getuserdetails',
      params: userId,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('something went wrong');
      });
  });

const insertUserManager = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/insertuser',
      data: params,
      method: 'POST',
    })
      .then((resp) => {
        console.log(resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const updateUserById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: 'hr-adm/updateuserbyid',
      data: params,
      method: 'PUT',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error encountered');
      });
  });

const getUserPointsList = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: 'hr-adm/getuserpoints',
      params: params,
      mehtod: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error occured in list api');
      });
  });

const updateUserPoints = async (parms) => {
  try {
    const response = await axios.put('/hr-adm/updateuserpoints', parms);
    return response.data;
  } catch { }
};

const getUserTransactions = async ({ current, pageSize, sortField, sortOrder, userId }) => {
  try {
    if (sortField === 'by_whom_user_name') {
      sortField = 'bywhom_username';
    }
    return await axios.get(
      `/hr-adm/gettransactionreportbyuserid?pg_num=${current}&pg_size=${pageSize}&sort_field=${sortField}&sort_order=${sortOrder}&userId=${userId}`
    );
  } catch (e) {
    console.log(e);
  }
};
const updateUserLockById = async (data) => {
  try {
    return await axios.put(
      `/hr-adm/updateuserlock`, data)
  }
  catch (e) {
    console.error(e)
    return e
  }
}

export { updateUserLockById, getUserPointsById, getUserDetailsById, insertUserManager, updateUserById, getUserPointsList, updateUserPoints, getUserTransactions, emailPassword };
